import { useEffect, useState } from "react";

export default function InstallPWAButton({ className }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => setInstalled(true);

    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || !deferred) return null;

  const doInstall = async () => {
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    setDeferred(null);
    console.log("[pwa] install outcome:", outcome);
  };

  return (
    <button onClick={doInstall} className={className || "btn-primary"}>
      Install App
    </button>
  );
}
